import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Trash2, UserRound } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { fadeUp, hoverLift, revealProps, stagger } from "@/lib/motion";

const ITEMS = [
  { icon: ShieldCheck, text: "Не просим документы, адреса и банковские данные" },
  { icon: UserRound, text: "Не публикуем сказки и данные ребёнка без вашего согласия" },
  { icon: Trash2, text: "Не храним лишнего: удалить свои данные можно в чате одной командой" },
];

const Safety = () => {
  return (
    <section id="safety" className="bg-night-800 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div {...revealProps} variants={stagger(0.08)} className="mb-12 text-center">
          <motion.p variants={fadeUp} className="mb-3 text-[11px] uppercase tracking-[0.22em] text-amber">
            Спокойно
          </motion.p>
          <motion.h2 variants={fadeUp} className="mb-4 font-serif text-3xl text-cream sm:text-4xl lg:text-5xl">
            Что мы не делаем
          </motion.h2>
          <motion.p variants={fadeUp} className="mx-auto max-w-lg leading-relaxed text-muted-foreground">
            Заботимся о конфиденциальности вашего ребёнка
          </motion.p>
        </motion.div>

        <motion.div {...revealProps} variants={stagger(0.1)} className="grid gap-4 sm:grid-cols-3 lg:gap-5">
          {ITEMS.map(({ icon: Icon, text }, i) => (
            <motion.div
              key={text}
              variants={fadeUp}
              whileHover={hoverLift}
              data-testid={`${LANDING.safetyItemPrefix}${i + 1}`}
              className="flex flex-col items-center gap-4 rounded-3xl border border-line bg-white/[0.04] p-7 text-center backdrop-blur-xl transition-colors duration-300 hover:border-amber/40"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-amber/25 bg-amber/10 text-amber">
                <Icon className="h-6 w-6" />
              </span>
              <p className="text-sm leading-relaxed text-muted-foreground">{text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Safety;
